import { RoomObjectType } from '../types/room';

export const getDisplayName = (contractAddress: string): string => {
  switch (contractAddress.toLowerCase()) {
    default:
      return 'Habbo Room';
    case '0x22925b8ab30cf3c9821077cbfe1e71282233b7c7':
    case '0x8a1bbef259b00ced668a8c69e50d92619c672176':
      return 'Habbo Avatar Room';
    case '0xa0e6e48a24714a0a8d5c9683042f7670916d314d':
    case '0xcd00c852c5f92469970070e18393f943d6fc522c':
      return 'Habbo X Room';
  }
};

export const formatRoomName = (nft: RoomObjectType): string =>
  nft.roomName ||
  nft.displayName ||
  `${getDisplayName(nft.contractAddress)} #${nft.tokenId}`;

export const cssBackground = (
  nft: RoomObjectType,
  image: string = ''
): { backgroundImage: string; backgroundColor: string } => {
  const result = {
    backgroundColor: nft.color || 'grey',
    backgroundImage: `url("${image || nft.cleanImageUrl || nft.imageUrl}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  return result;
};
